// Tipo di contenuto: reel (video) o post grafico (solo copy + immagine).
//
// Il post grafico non passa da Riprese né da Editing: appena il testo è
// confermato va dritto in "da programmare". Qui i predicati unici, da
// importare nelle pagine invece di confrontare `tipo` a mano.

import { Cliente, Contenuto, FormatoPost, StatoContenuto, TipoContenuto } from '../types';

export const isPost = (c: Pick<Contenuto, 'tipo'>): boolean => c.tipo === 'post';

export const tipoDi = (c: Pick<Contenuto, 'tipo'>): TipoContenuto => (c.tipo === 'post' ? 'post' : 'reel');

export const ETICHETTA_TIPO: Record<TipoContenuto, string> = {
  reel: 'Reel',
  post: 'Post',
};

// Due formati di post (03/11/2026, Michel): il post grafico è un carosello in
// computer grafica, il carosello foto sono foto reali scattate nel locale.
// Entrambi saltano Riprese ed Editing; cambia chi fa le immagini in
// post.bymarke.com (Post grafici / Caroselli & foto).
export const formatoDi = (c: Pick<Contenuto, 'formatoPost'>): FormatoPost => (c.formatoPost === 'foto' ? 'foto' : 'grafica');
export const isCaroselloFoto = (c: Pick<Contenuto, 'tipo' | 'formatoPost'>): boolean => isPost(c) && c.formatoPost === 'foto';
export const ETICHETTA_FORMATO: Record<FormatoPost, string> = {
  grafica: 'Post grafico',
  foto: 'Carosello foto',
};
export const DESCRIZIONE_FORMATO: Record<FormatoPost, string> = {
  grafica: 'Post grafico: carosello in computer grafica, solo copy e immagini, senza riprese né montaggio',
  foto: 'Carosello foto: foto reali scattate nel locale, solo copy e foto, senza riprese né montaggio',
};
/**
 * Come chiamare il giorno da post di un cliente (03/11/2026, Michel su Gran Galà: «non "post" ma
 * "carosello foto"»): dalla scheda, se i suoi post sono tutti caroselli foto «Carosello foto», se
 * sono tutti grafici «Post grafico», «Post» solo se fa tutti e due.
 */
export const etichettaPostCliente = (cliente?: Pick<Cliente, 'postGraficiSettimana' | 'caroselliFotoSettimana'> | null): string => {
  const totale = cliente?.postGraficiSettimana || 0;
  const foto = Math.min(cliente?.caroselliFotoSettimana || 0, totale);
  if (totale > 0 && foto === totale) return ETICHETTA_FORMATO.foto;
  if (foto === 0) return ETICHETTA_FORMATO.grafica;
  return 'Post';
};
/** Il formato atteso nel giorno da post: 'foto' / 'grafica' se il cliente ne fa uno solo, se no null. */
export const formatoPostCliente = (cliente?: Pick<Cliente, 'postGraficiSettimana' | 'caroselliFotoSettimana'> | null): FormatoPost | null => {
  const e = etichettaPostCliente(cliente);
  return e === ETICHETTA_FORMATO.foto ? 'foto' : e === ETICHETTA_FORMATO.grafica ? 'grafica' : null;
};

/** «Reel», «Post grafico» o «Carosello foto». */
export const etichettaDi = (c: Pick<Contenuto, 'tipo' | 'formatoPost'>): string =>
  isPost(c) ? ETICHETTA_FORMATO[formatoDi(c)] : 'Reel';

// "Pronto per la programmazione": un reel ci arriva quando è registrato (o
// forzato dal pulsante Programma del Videomaker); un post grafico appena il
// testo è confermato, perché non c'è niente da girare né da montare.
export const prontoPerProgrammazione = (c: Contenuto): boolean =>
  isPost(c) ? c.stato !== StatoContenuto.BOZZA : Boolean(c.videoRegistrato || c.prontoDaProgrammare);
